var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"otpGroup",attrs:{"name":"otp-group"}},[_vm._t("default",null,{"focusNext":_vm.focusNext,"focusPrev":_vm.focusPrev})],2)}
var staticRenderFns = []

export { render, staticRenderFns }